"use strict";
/**
 * Created by rouven on 08.03.17.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var stringifyValue_1 = __importDefault(require("./stringifyValue"));
exports["default"] = (function (rawOptions) { return rawOptions
    ? Object.keys(rawOptions).map(function (rawOptionKey) { return ({
        value: (0, stringifyValue_1["default"])(rawOptionKey),
        label: rawOptions[rawOptionKey]
    }); })
    : []; });
